CustomTC.requirejs.config({
    baseUrl: 'src',
    paths: {
        'jquery': 'lib/bower_components/jquery/src',
        'sizzle': 'lib/bower_components/jquery/src/sizzle/dist/sizzle',
        'clipboard': 'lib/bower_components/clipboard/dist',
        'tooltipster' : 'lib/bower_components/tooltipster',
        'FlashDetect' : 'lib/bower_components/FlashDetect',
        'text': 'lib/bower_components/requirejs/text',
        'hls': 'lib/bower_components/hls.js/dist',
        'platformjs': 'lib/bower_components/platform.js'
    },
    map: {
        '*': {
            'css': 'lib/bower_components/require-css/css'
        }
    }
});
CustomTC.requirejs(["main"]);
CustomTC.define("app", function(){});

